
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course-collection/agentic-ai",
      function () {
        return require("private-next-pages/course-collection/agentic-ai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course-collection/agentic-ai"])
      });
    }
  